import { firestorage } from "@/firebase/firestorage";
import firestore from "../../../firebase/firestore";
import { getCards } from "../../../services/support/cards";

export default {
  resetFilter({ commit }) {
    commit("resetState");
    commit("setActiveBilling", 0);
    commit("setActiveCards", 0);
  },
  async getUserByParams({ commit, dispatch, state }, params) {
    try {
      commit("setActiveBilling", 0);
      commit("setLoading", true);
      // console.log('params: ', params)
      if (params) {
        let userRef = firestore.collection("users");
        let consumerUnitRef = firestore.collection("consumer_units");
        let ucNotFound = false;
        if (params.email) {
          userRef = userRef.where("email", "==", params.email);
        } else if (params.cpf) {
          userRef = userRef.where("cpf", "==", params.cpf);
        } else if (params.phone) {
          userRef = userRef.where("phone", "==", params.phone);
        } else if (params.installation_number) {
          await consumerUnitRef
            .doc(params.installation_number)
            .get()
            .then((uc) => {
              // console.log('uc: ', uc.data())
              userRef = userRef.where("customer_id", "==", uc.data().user_id);
            })
            .catch((err) => {
              console.error("Erro ao buscar unidade consumidora.", err);
              commit("setCustomer", {});
              commit("userCSError", err);
              commit("setLoading", false);
              ucNotFound = true;
            });
        }
        if (ucNotFound) return;
        return userRef
          .limit(1)
          .onSnapshot({ includeMetadataChanges: true }, async (users) => {
            // const changes = res.docChanges();
            if (users.size > 0) {
              // console.log('users:', {id: users.docs[0].id, ...users.docs[0].data()})
              await commit("setCustomer", {
                id: users.docs[0].id,
                ...users.docs[0].data(),
              });
              await commit("setUserNotFound", false);
              if (!params.installation_number) {
                await dispatch("getConsumerUnitsByUser", {
                  user_id: users.docs[0].id,
                  uc: null,
                });
              } else {
                await dispatch("getConsumerUnitsByUser", {
                  user_id: users.docs[0].id,
                  uc: params.installation_number,
                });
              }
              await dispatch("getHistoryByUser", users.docs[0].id);
              // dispatch('getCardsByUser', users.docs[0].cards)
              await dispatch("getNegativation", users.docs[0].id);
              await dispatch("getBillingOverdueByUser", users.docs[0].id);
              if (!state.overdue)
                await dispatch(
                  "getBillingGroupOverdueByUser",
                  users.docs[0].id,
                );
              // this.getConsumerUnitsByUser({commit}, users.docs[0].id)
            } else {
              // console.log('setUserNotFound', users)
              await commit("setCustomer", {});
              await commit("setUserNotFound", true);
              // console.log('us: ', users)
            }
            await commit("setLoading", false);
          });
      }
    } catch (err) {
      await commit("setCustomer", {});
      await commit("userCSError", err);
      console.error(err);
      await commit("setLoading", false);
    }
  },
  async getConsumerUnitsByUser({ commit }, params) {
    // console.log('getConsumerUnitsByUser')
    return await firestore
      .collection("consumer_units")
      .where("user_id", "==", params.user_id)
      .onSnapshot(function (querySnapshot) {
        let new_ucs = querySnapshot.docs.map((uc) => {
          return { id: uc.id, ...uc.data() };
        });
        commit("setConsumerUnits", new_ucs);
        if (new_ucs.length > 0) {
          if (params.uc) {
            new_ucs.map((uc, idx) => {
              if (uc.id === params.uc) {
                commit("setConsumerUnit", new_ucs[idx]);
                commit("addConsumerUnitsOpened", new_ucs[idx]);
              }
            });
          } else {
            commit("setConsumerUnit", new_ucs[0]);
            commit("addConsumerUnitsOpened", new_ucs[0]);
          }

          // dispatch('getBillingByConsumerUnit', new_ucs[0].id)
        }
      });
  },
  async getCardsByUser({ commit }, cards) {
    // console.log('getCardsByUser')
    commit("setLoadingCards", true);
    // console.log('cards: ', cards)
    if (cards && cards.length >= 0) {
      let _cards = await getCards(cards);
      // let _cards = []
      // console.log('_cards: ',  _cards)
      if (_cards) await commit("setCards", _cards);
      await commit("setLoadingCards", false);
      // return _cards
    } else {
      await commit("setLoadingCards", false);
      // return null
    }
    // return
  },

  /* eslint-disable */
  async getPowerPlantByID({ commit }, id) {
    try {
      const power_plant = await firestore
        .collection("power_plants")
        .where("installation_number", "==", id)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            const data = querySnapshot.docs[0].data();
            return { id: querySnapshot.docs[0].id, ...data };
          }
          return null;
        });
      return power_plant;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  async getBillingByConsumerUnit({ commit }, consumerUnitID) {
    // console.log('getBillingByConsumerUnit')
    let new_billings = [];
    // console.log('getBillingByConsumerUnit - consumerUnitID: ', consumerUnitID)
    commit("setLoadingBillingCS", true);
    return await firestore
      .collection("billing")
      .where("consumer_unit", "==", consumerUnitID)
      .orderBy("competence", "desc")
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            new_billings.splice(newIndex, 0, new_doc);
            // this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            // new_billings.splice(oldIndex, 1)
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            new_billings.splice(oldIndex, 1, new_doc);
          } else if (type === "removed") {
            new_billings.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          }
        });
        // console.log('new_billings: ', new_billings)
        await commit("setBillings", new_billings);
        await commit("setLoadingBillingCS", false);
        return new_billings;
      });
  },

  async getBillings({ commit }, consumerUnit) {
    // console.log('getBillingByConsumerUnit')
    let new_billings = [];
    // console.log('getBillingByConsumerUnit - consumerUnitID: ', consumerUnitID)
    commit("setLoadingBillingCS", true);
    return await firestore
      .collection("billing")
      .where("consumer_unit", "==", consumerUnit.id)
      .where("customer_id", "==", consumerUnit.user_id)
      .orderBy("competence", "desc")
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { doc } = change;
          switch (change.type) {
            case "added": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              new_billings.push(data);
              break;
            }
            case "modified": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              // eslint-disable-next-line no-shadow
              const i = new_billings.findIndex((i) => i.id === doc.id);
              new_billings.splice(i, 1, data);
              // new_billings[i] = data
              // console.log('modified after splice2', invoices)
              break;
            }
            case "removed": {
              new_billings = new_billings.filter((i) => i.id !== doc.id);
              break;
            }
            default:
              break;
          }
          // if(change.type === 'added') {
          //     let new_doc = {
          //         ...doc.data(),
          //         id: change.doc.id,
          //     }
          //     new_billings.splice(newIndex, 0, new_doc)
          //     // this.loading = false;
          //     // if we want to handle references we would do it here
          // } else if(change.type === 'modified') {
          //     // remove the old one first
          //     // new_billings.splice(oldIndex, 1)
          //     // if we want to handle references we would have to unsubscribe
          //     // from old references' listeners and subscribe to the new ones
          //     let new_doc = {
          //         ...change.doc.data(),
          //         id: change.doc.id,
          //     }
          //     new_billings.splice(newIndex, oldIndex, new_doc)
          // } else if (type === 'removed') {
          //     new_billings.splice(oldIndex, 1)
          //     // if we want to handle references we need to unsubscribe
          //     // from old references
          // }
        });
        // console.log('new_billings: ', new_billings)
        await commit("setBillings", new_billings.reverse());
        await commit("setLoadingBillingCS", false);
        return new_billings;
      });
  },

  async getSpecialBillings({ commit }, consumerUnit) {
    try {
      commit("setSpecialBillings", []);
      if (consumerUnit?.user_id) {
        commit("setLoadingBillingCS", true);
        let new_billings = [];

        const [joinedBillingRef, debtBillingRef] = await Promise.all([
          firestore
            .collection("debt_billing")
            .where("customer_id", "==", consumerUnit.user_id)
            .where("joined_billings", "==", true)
            .get(),
          firestore
            .collection("debt_billing")
            .where("consumer_unit", "==", consumerUnit.id)
            .get(),
        ]);

        const filteredDebtBilling = debtBillingRef.docs.filter((doc) => {
          const joinedBillings = doc.data().joined_billings;
          return !joinedBillings;
        });

        const joinedBillingDocs = joinedBillingRef.docs;
        const debtBillingDocs = filteredDebtBilling;
        const combinedDocs = [...joinedBillingDocs, ...debtBillingDocs];

        for (const _bill of combinedDocs) {
          const bill = { ..._bill?.data(), id: _bill?.id };

          switch (true) {
            case !!bill.deal:
              bill.reason = "deal";
              break;
            case !!bill.fine:
              bill.reason = "fine";
              break;
            case !!bill.joined_billings:
              bill.reason = "joined_billings";
              break;
            case !!bill.cancellation_charge:
              bill.reason = "canceled_by_juntos";
              break;
            default:
              bill.reason = "other";
              break;
          }

          if (
            bill.fine ||
            bill.deal ||
            bill.joined_billings ||
            bill.cancellation_charge
          )
            new_billings.push(bill);
        }

        let billingRef = await firestore
          .collection("billing")
          .where("customer_id", "==", consumerUnit.user_id)
          .where("is_cancel_billing", "==", true)
          .get();
        for (const _bill of billingRef.docs) {
          const bill = _bill?.data();
          bill.reason = "closing_billing";
          new_billings.push(bill);
        }

        commit("setSpecialBillings", new_billings);
        commit("setLoadingBillingCS", false);
        return true;
      }
    } catch (err) {
      commit("setBillingItems", []);
      commit("setLoadingBillingCS", false);
      console.error(err);
    }
  },

  async getBillingOverdueByUser({ commit }, userID) {
    // console.log('getBillingOverdueByUser')
    // console.log('getBillingByConsumerUnit - consumerUnitID: ', consumerUnitID)
    commit("setLoadingBillingCS", true);
    return await firestore
      .collection("billing")
      .where("customer_id", "==", userID)
      .where("status", "in", ["overdue", "refused"])
      .limit(1)
      .get()
      .then((billings) => {
        if (billings.size > 0) commit("setOverdue", true);
        commit("setLoadingBillingCS", false);
        return true;
      })
      .catch((err) => {
        console.error("Erro ao buscar inadimplencia. ", err.message);
        commit("setLoadingBillingCS", false);
        return false;
      });
  },

  async getBillingGroupOverdueByUser({ commit }, userID) {
    commit("setLoadingBillingCS", true);
    return await firestore
      .collection("debt_billing")
      .where("customer_id", "==", userID)
      .where("status", "in", ["overdue", "refused"])
      .limit(1)
      .get()
      .then((billings) => {
        if (billings.size > 0) commit("setOverdue", true);
        commit("setLoadingBillingCS", false);
        return true;
      })
      .catch((err) => {
        console.error("Erro ao buscar inadimplencia. ", err.message);
        commit("setLoadingBillingCS", false);
        return false;
      });
  },

  async getHistoryByUser({ commit }, customer_id) {
    // console.log('getHistoryByUser')
    let new_history = [];
    // console.log('consumerUnitID: ', consumerUnitID)
    return await firestore
      .collection("history")
      .where("customer_id", "==", customer_id)
      .orderBy("created_at", "desc")
      .limit(20)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        // let new_billings  = await billings.docs.map(billing => {
        //     return {id: billing.id, ...billing.data()}
        // })
        // console.log('new_billings: ', new_billings)
        // commit('setBillings', new_billings)
        // return new_billings
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            new_history.splice(newIndex, 0, new_doc);
            // this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            new_history.splice(oldIndex, 1);
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            new_history.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            new_history.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          }
        });
        // console.log('new_history: ', new_history)
        commit("setHistory", new_history);
        return new_history;
      });
  },
  async getObservationsByUser({ commit }, customer_id) {
    // console.log('getObservationsByUser')
    let new_observations = [];
    // console.log('consumerUnitID: ', consumerUnitID)
    return await firestore
      .collection("users")
      .doc(customer_id)
      .collection("observations")
      .orderBy("created_at", "desc")
      .limit(10)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        // let new_billings  = await billings.docs.map(billing => {
        //     return {id: billing.id, ...billing.data()}
        // })
        // console.log('new_billings: ', new_billings)
        // commit('setBillings', new_billings)
        // return new_billings
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            new_observations.splice(newIndex, 0, new_doc);
            // this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            new_observations.splice(oldIndex, 1);
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            new_observations.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            new_observations.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          }
        });
        // console.log('new_observations: ', new_observations)
        commit("setObservations", new_observations);
        return new_observations;
      });
  },
  deleteObservation({ commit }, user_id, observation_id) {
    return firestore
      .collection("users")
      .doc(user_id)
      .collection("observations")
      .doc(observation_id)
      .delete()
      .then((res) => {
        commit("setObservation", null);
        return res;
      })
      .catch((err) => {
        console.error(err);
        return err.message;
      });
  },
  editObservation({ commit }, observation) {
    commit("setObservation", observation);
    return observation;
  },
  async getTasksByParam({ commit }, payload) {
    // console.log('getTasksByParam')
    // console.log('id: ', payload.id)
    // console.log('type: ', payload.type)
    let taskRef = firestore.collection("tasks").orderBy("due", "asc");
    if (payload.type === "responsible" && payload.id) {
      taskRef = taskRef.where("responsible_id", "==", payload.id);
    } else if (payload.type === "user" && payload.id) {
      taskRef = taskRef.where("user_id", "==", payload.id);
    } else if (payload.type === "departament" && payload.id) {
      taskRef = taskRef.where("departament_id", "in", payload.id);
      taskRef = taskRef.where("free", "==", true);
    }
    if (payload.loaded) {
      taskRef = taskRef.startAfter(
        await firestore
          .doc(`tasks/${payload.loaded[payload.loaded.length - 1].id}`)
          .get(),
      );
    }
    let newTasks = [];
    // console.log('consumerUnitID: ', consumerUnitID)
    return await taskRef.limit(5).onSnapshot(async (res) => {
      const changes = res.docChanges();
      await changes.forEach((change) => {
        // console.log('change: ', change)
        const { newIndex, oldIndex, doc, type } = change;
        if (change.type === "added") {
          let new_doc = {
            ...doc.data(),
            id: change.doc.id,
          };
          newTasks.splice(newIndex, 0, new_doc);
          // this.loading = false;
          // if we want to handle references we would do it here
        } else if (change.type === "modified") {
          // remove the old one first
          newTasks.splice(oldIndex, 1);
          // if we want to handle references we would have to unsubscribe
          // from old references' listeners and subscribe to the new ones
          let new_doc = {
            ...change.doc.data(),
            id: change.doc.id,
          };
          newTasks.splice(newIndex, 0, new_doc);
        } else if (type === "removed") {
          newTasks.splice(oldIndex, 1);
          // if we want to handle references we need to unsubscribe
          // from old references
        }
      });
      // console.log('tasksx: ', tasks)
      if (payload.loaded) commit("setTasks", [...payload.loaded, ...newTasks]);
      else commit("setTasks", newTasks);
      return newTasks;
    });
  },
  async getTasks({ commit }) {
    // console.log('getTasks')
    let tasks = [];
    // console.log('consumerUnitID: ', consumerUnitID)
    return await firestore
      .collection("tasks") //.where('user_id', '==', user_id)
      // .orderBy('updated_at', 'desc')
      .limit(10)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            tasks.splice(newIndex, 0, new_doc);
            // this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            tasks.splice(oldIndex, 1);
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            tasks.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            tasks.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          }
        });
        commit("setTasks", tasks);
        return tasks;
      });
  },
  // eslint-disable-next-line
  async addTask({ commit }, payload) {
    // console.log(new Date())
    // console.log(payload.content)
    // console.log(payload.created_by_id)
    // console.log(payload.created_by_name)
    // console.log(payload.departament_id)
    // console.log(payload.due)
    // console.log(payload.responsible_id)
    // console.log(payload.responsible_name)
    // console.log(payload.user_id)
    // console.log(payload.priority)
    const task = {
      created_at: new Date(),
      content: payload.content,
      created_by_id: payload.created_by_id,
      created_by_name: payload.created_by_name,
      departament_id: payload.departament_id,
      due: new Date(payload.due),
      responsible_id:
        payload.responsible_id !== undefined ? payload.responsible_id : null,
      responsible_name:
        payload.responsible_name !== undefined
          ? payload.responsible_name
          : null,
      free: payload.responsible_id !== undefined ? false : true,
      user_id: payload.user_id,
      priority: parseInt(payload.priority),
      status: "open",
      auto_reminder: true,
    };
    firestore.collection("tasks").add(task);
  },
  // eslint-disable-next-line
  async addCommentInTask({ commit }, payload) {
    // console.log(new Date())
    // console.log(payload)
    const comment = {
      created_at: new Date(),
      content: payload.content,
      created_by_id: payload.created_by_id,
      created_by_name: payload.created_by_name,
    };
    // console.log(comment)
    await firestore
      .collection("tasks")
      .doc(payload.task.id)
      .collection("comments")
      .add(comment);
  },
  async setSelectedTask({ commit }, payload) {
    // console.log('setSelectedTask')
    // console.log('payload task', payload.task)
    let comments = [];
    // console.log('getting comments for: ', payload.task.id)
    await firestore
      .collection("tasks")
      .doc(payload.task.id)
      .collection("comments")
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            comments.splice(newIndex, 0, new_doc);
          } else if (change.type === "modified") {
            comments.splice(oldIndex, 1);
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            comments.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            comments.splice(oldIndex, 1);
          }
        });
        // console.log('comments:', comments)
        payload.task.comments = comments;
        // console.log(payload.task)
        commit("setTask", payload.task);
      });
  },
  // eslint-disable-next-line
  async updateTaskResponsible({ commit }, payload) {
    // console.log('task id', payload.task.id)
    // console.log('responsible id', payload.responsible_id)
    // console.log('responsible name', payload.responsible_name)
    await firestore.collection("tasks").doc(payload.task.id).update({
      responsible_id: payload.responsible_id,
      responsible_name: payload.responsible_name,
      free: false,
    });
  },
  async updateTaskStatus({ commit }, payload) {
    // console.log('task id', payload.task.id)
    // console.log('status', payload.status)
    await firestore.collection("tasks").doc(payload.task.id).update({
      status: payload.status,
    });
    payload.task.status = payload.status;
    commit("setTask", payload.task);
  },
  async getAgents({ commit }, payload) {
    // console.log('getAgents')
    let agents = [];
    return await firestore
      .collection("users")
      .where("group", "in", payload.categories)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
            };
            agents.splice(newIndex, 0, new_doc);
            // this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            agents.splice(oldIndex, 1);
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            agents.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            agents.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          }
        });
        // console.log('agents: ', agents)
        commit("setAgents", agents);
        return agents;
      });
  },
  async getActivities({ commit }, payload) {
    // console.log('getActivities')
    let activitiesRef = firestore
      .collection("history")
      .where("customer_id", "==", payload.user_id)
      .orderBy("created_at", "desc");
    if (payload.loaded) {
      activitiesRef = activitiesRef.startAfter(
        await firestore
          .doc(`history/${payload.loaded[payload.loaded.length - 1].id}`)
          .get(),
      );
    }
    let activities = [];
    return await activitiesRef.limit(5).onSnapshot(async (res) => {
      const changes = res.docChanges();
      await changes.forEach((change) => {
        const { newIndex, oldIndex, doc, type } = change;
        if (change.type === "added") {
          let new_doc = {
            ...doc.data(),
            id: change.doc.id,
          };
          activities.splice(newIndex, 0, new_doc);
          // this.loading = false;
          // if we want to handle references we would do it here
        } else if (change.type === "modified") {
          // remove the old one first
          activities.splice(oldIndex, 1);
          // if we want to handle references we would have to unsubscribe
          // from old references' listeners and subscribe to the new ones
          let new_doc = {
            ...change.doc.data(),
            id: change.doc.id,
          };
          activities.splice(newIndex, 0, new_doc);
        } else if (type === "removed") {
          activities.splice(oldIndex, 1);
          // if we want to handle references we need to unsubscribe
          // from old references
        }
      });
      // console.log('activities: ', activities)
      if (payload.loaded)
        commit("setActivities", [...payload.loaded, ...activities]);
      else commit("setActivities", activities);
      return activities;
    });
  },
  async getNegativation({ commit }, payload) {
    // console.log('getNegativation')
    let negativationRef = firestore
      .collection("users")
      .doc(payload)
      .collection("negativation");
    let negativations = [];
    return await negativationRef
      // .limit(5)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: change.doc.id,
              user_id: payload,
            };
            negativations.splice(newIndex, 0, new_doc);
            // this.loading = false;
            // if we want to handle references we would do it here
          } else if (change.type === "modified") {
            // remove the old one first
            negativations.splice(oldIndex, 1);
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            let new_doc = {
              ...change.doc.data(),
              id: change.doc.id,
              user_id: payload,
            };
            negativations.splice(newIndex, 0, new_doc);
          } else if (type === "removed") {
            negativations.splice(oldIndex, 1);
            // if we want to handle references we need to unsubscribe
            // from old references
          }
        });
        // console.log('negativations: ', negativations)
        commit("setNegativations", negativations);
        // console.log('neg: ', negativations)
        return negativations;
      });
  },
  async updateConsumerUnit({ commit }, payload) {
    let consumerUnitRef = firestore
      .collection("consumer_units")
      .doc(payload.id);
    return consumerUnitRef
      .update(payload.data)
      .then(async () => {
        let doc_uc = await consumerUnitRef.get();
        commit("setConsumerUnit", { id: doc_uc.id, ...doc_uc.data() });
        return doc_uc;
      })
      .catch((err) => {
        console.error(err);
        return err;
      });
  },

  async getContractsByUC({ state, commit }, consumerUnitID) {
    await commit("setContracts", []);
    try {
      const contractsRef = firestore
        .collection("consumer_units")
        .doc(consumerUnitID)
        .collection("contracts");

      return contractsRef.onSnapshot(async (res) => {
        await commit("setLoading", true);
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                await commit("pushContract", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.contracts.findIndex((i) => i.id === doc.id);
                await commit("spliceContracts", { index, data });
                break;
              }
              case "removed": {
                const newContracts = state.contracts.filter(
                  (i) => i.id !== doc.id,
                );
                await commit("setContracts", newContracts);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setContracts", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setContracts", []);
      console.error(err);
    }
  },

  async getAccountBalanceHistory({ commit }, consumer_unit_id) {
    try {
      const accountBalanceHistoryRef = firestore
        .collection("consumer_units")
        .doc(consumer_unit_id)
        .collection("account_balance_history");

      return accountBalanceHistoryRef.onSnapshot(async (res) => {
        await commit("setLoading", true);
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            const data = {
              id: doc.id,
              ...doc.data(),
            };
            await commit("pushAccountBalanceHistory", data);
          });
          return true;
        }
        await commit("setAccountBalanceHistory", []);
      });
    } catch (err) {
      await commit("setAccountBalanceHistory", []);
      console.error(err);
    } finally {
      await commit("setLoading", false);
    }
  },

  async getIdPhotos({ state, commit }, userID) {
    commit("setDocuments", []);
    const idPhotos = [];
    try {
      commit("setLoading", true);
      await firestore
        .collection("users")
        .doc(userID)
        .collection("document_photo")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            idPhotos.push(doc.data());
          });
        });

      const user = (
        await firestore.collection("users").doc(userID).get()
      ).data();
      const docs = [
        user?.id_card_photo_1,
        user?.id_card_photo_2,
        user?.id_card_selfie,
      ].filter((item) => item != undefined);

      for (const doc of docs) {
        const ref = firestorage.ref().child(doc);
        ref
          .getDownloadURL()
          .then((url) => {
            // eslint-disable-next-line no-useless-escape
            const name = doc.match(/\/([^\/]+)\.[^.]+$/)[1];

            if (!state.documents?.find((item) => item.name == name)) {
              commit("pushDocument", {
                url: url,
                name: name,
                origin: "uploads",
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

      commit("setLoading", false);
      if (idPhotos.length > 0) {
        commit("setDocuments", idPhotos);
      } else {
        commit("setDocuments", []);
      }
      return idPhotos;
    } catch (err) {
      console.error(err);
      commit("setLoading", false);
    }
  },

  async getReferralsByIndicatorEmail({ state, commit }, email) {
    await commit("setReferrals", []);
    try {
      const referralRef = firestore
        .collection("referral")
        .where("referral_indicator", "==", email);

      return referralRef.onSnapshot(async (res) => {
        await commit("setLoading", true);
        console.log("referral: ", res.size);
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                await commit("pushReferral", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.referrals.findIndex((i) => i.id === doc.id);
                await commit("spliceReferral", { index, data });
                break;
              }
              case "removed": {
                const newReferrals = state.referrals.filter(
                  (i) => i.id !== doc.id,
                );
                await commit("setReferrals", newReferrals);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setReferrals", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setReferrals", []);
      console.error(err);
    }
  },

  async getProvisionedBillings({ commit }, consumerUnit) {
    const provisionedBillings = [];
    commit("setLoadingBillingCS", true);
    return firestore
      .collection("billing_provision")
      .where("consumer_unit", "==", consumerUnit.id)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        changes.forEach(async (change) => {
          const { doc } = change;
          switch (change.type) {
            case "added": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              provisionedBillings.push(data);
              break;
            }
            case "modified": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              const index = provisionedBillings.findIndex(
                (i) => i.id === doc.id,
              );
              provisionedBillings.splice(index, 1, data);
              break;
            }
            case "removed": {
              const newBillings = provisionedBillings.filter(
                (i) => i.id !== doc.id,
              );
              await commit("setProvisionedBillings", newBillings.reverse());
              break;
            }
            default:
              break;
          }
        });
        await commit("setProvisionedBillings", provisionedBillings.reverse());
        await commit("setLoadingBillingCS", false);
        return provisionedBillings;
      });
  },
  async getPartnerName(context, id) {
    const partner = await firestore.collection("partners").doc(id).get();

    return partner?.data()?.name;
  },
};
